export default __webpack_public_path__ + "static/media/ASSETS-10.7eaf3108.png";